import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./components/Context/ContextAPI";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Drawer from "@mui/material/Drawer";
import { motion, AnimatePresence } from "framer-motion";

import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

import {
  Box,
  Typography,
  Modal,
  Stack,
  Button,
  useMediaQuery,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  Snackbar,
  Alert,
} from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";
import Logo from "./assets/spero_logo.png";
import SOS from "./assets/sos.png";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import CloseIcon from "@mui/icons-material/Close";
import "./Navbar.css";
import HRHeader from "./components/HR/HRHeader";
import { API_URL } from "./components/Config/api";
import { useCall } from "./components/Context/CallContext";
import LocalCafeIcon from "@mui/icons-material/LocalCafe";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { API_URL_CALL } from "./components/Config/GrandStreamApi/api";
import { SOCKET_URL_CALL } from "./components/Config/GrandStreamApi/fast_api";

export default function Navbar() {
  const userGroup = localStorage.getItem("user_group");
  const navigate = useNavigate();
  const { handleAuthLogout } = useAuth();
  const accessToken = localStorage.getItem("token");
  const addedby = localStorage.getItem("clg_id");

  const accessHospitalName = localStorage.getItem("hospitalName");
  const accessHospitalID = localStorage.getItem("hospitalID") || 0;

  const [hospital, setHospital] = useState([]);
  const [selectedHospital, setSelectedHospital] = useState(0);
  const [auth, setAuth] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);

  // Modals States
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenHosp, setIsModalOpenHosp] = useState(false);
  const [isBreakModalOpen, setIsBreakModalOpen] = useState(false);

  // Snackbar State
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success", // Can be "success" or "error"
  });

  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const [state, setState] = useState({ right: false });
  const [sosData, setSOSData] = useState([]);
  const [profID, setProfID] = useState("");
  const [remark, setRemark] = useState("");
  const [remarkError, setRemarkError] = useState({ remark: "" });

  const userPicture = localStorage.getItem("user-image");
  const userName = localStorage.getItem("user-name");
  const userLastName = localStorage.getItem("user-lname");
  const userDesignation = localStorage.getItem("user-designation");
  const userEmail = localStorage.getItem("user-email");
  const userPhone = localStorage.getItem("user-phone");
  const userAddress = localStorage.getItem("user-loc");
  const userID = localStorage.getItem("clg_id");

  // ==========================================
  // --- PAUSE / UNPAUSE STATES & LOGIC ---
  // ==========================================
  const [isPaused, setIsPaused] = useState(
    localStorage.getItem("is_paused") === "true",
  );
  const [breakTypes, setBreakTypes] = useState([]);
  const [selectedBreakType, setSelectedBreakType] = useState("");
  const [breakTimeId, setBreakTimeId] = useState(
    localStorage.getItem("active_break_id") || null,
  );

  // --- LIVE TIMER STATE & LOGIC ---
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    let interval;
    if (isPaused) {
      let startTime = localStorage.getItem("break_start_time");
      if (!startTime) {
        startTime = Date.now().toString();
        localStorage.setItem("break_start_time", startTime);
      }
      interval = setInterval(() => {
        setElapsedTime(Math.floor((Date.now() - parseInt(startTime)) / 1000));
      }, 1000);
    } else {
      setElapsedTime(0);
    }
    return () => clearInterval(interval);
  }, [isPaused]);

  const formatTimeDisplay = (totalSeconds) => {
    const hrs = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    if (hrs > 0) {
      return `${hrs.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    }
    return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };
  // --------------------------------

  const extensionLogin = localStorage.getItem("selected_extension");
  const isCloudValue = extensionLogin !== "1111";

  const { disconnectSocket } = useCall();

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ right: open });
  };

  const handleEmptyRemark = () => {
    const newErrors = {};
    if (!remark) newErrors.remark = "Remark is required";
    setRemarkError(newErrors);
    return Object.values(newErrors).some((error) => error !== "");
  };

  const handleMenu = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleProfile = () => setIsModalOpen(true);
  const handleHospital = () => setIsModalOpenHosp(true);

  function formatTime(originalTime) {
    return new Date(originalTime).toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  useEffect(() => {
    const getHospital = async () => {
      try {
        const res = await fetch(`${API_URL}/web/select_hospital_name`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        const data = await res.json();
        setHospital(data);
      } catch (error) {
        console.error("Error fetching Hospital data:", error);
      }
    };
    if (accessToken) getHospital();
  }, [accessToken]);

  useEffect(() => {
    const fetchBreakTypes = async () => {
      try {
        const res = await fetch(`${API_URL}/web/break_type/`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        const data = await res.json();
        setBreakTypes(data);
      } catch (error) {
        console.error("Error fetching break types:", error);
      }
    };
    if (accessToken) fetchBreakTypes();
  }, [accessToken]);

  const handlePause = async () => {
    if (!selectedBreakType) {
      showSnackbar("Please select a break type from the dropdown.", "error");
      return;
    }

    const breakObj = breakTypes.find(
      (b) => b.break_type_id === selectedBreakType,
    );
    const reasonText = breakObj ? breakObj.break_type_name : "Meeting";

    const payload = {
      clg_ref_id: parseInt(userID, 10),
      pause: true,
      reason: reasonText,
      extension: parseInt(extensionLogin, 10),
      break_type_id: selectedBreakType,
      is_cloud: isCloudValue,
    };

    try {
      const response = await fetch(`${API_URL}/web/pause-agent/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        setIsPaused(true);
        localStorage.setItem("is_paused", "true");
        localStorage.setItem("break_start_time", Date.now().toString()); // Start timer
        if (data.break_time_id) {
          setBreakTimeId(data.break_time_id);
          localStorage.setItem("active_break_id", data.break_time_id);
        }
        setIsBreakModalOpen(false);
        showSnackbar(`Break Started: ${reasonText}`, "success");
      } else {
        showSnackbar(
          "Failed to Start Break: " + (data.message || "Unknown error"),
          "error",
        );
      }
    } catch (error) {
      console.error("Pause Error:", error);
      showSnackbar("Connection failed while starting break.", "error");
    }
  };

  const handleUnpause = async () => {
    const currentBreakId =
      breakTimeId || localStorage.getItem("active_break_id");

    const payload = {
      clg_ref_id: parseInt(userID, 10),
      break_time_id: currentBreakId ? parseInt(currentBreakId, 10) : 10,
      pause: false,
      queue: "6501",
      extension: parseInt(extensionLogin, 10),
      is_cloud: isCloudValue,
    };

    try {
      const response = await fetch(`${API_URL}/web/unpause-agent/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        setIsPaused(false);
        localStorage.removeItem("is_paused");
        localStorage.removeItem("active_break_id");
        localStorage.removeItem("break_start_time"); // Clear timer
        setBreakTimeId(null);
        setSelectedBreakType("");
        showSnackbar("Break Ended Successfully!", "success");
      } else {
        showSnackbar(
          "Failed to End Break: " + (data.message || "Unknown error"),
          "error",
        );
      }
    } catch (error) {
      console.error("Unpause Error:", error);
      showSnackbar("Connection failed while ending break.", "error");
    }
  };

  const handleHospitalSubmit = async () => {
    const response = await fetch(`${API_URL}/web/select_hospital_name`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ hosp_id: selectedHospital }),
    });
    if (!response.ok) return;
    const result = await response.json();
    localStorage.setItem("hospitalID", result.hosp_id);
    localStorage.setItem("hospitalName", result.hospital_name);
    window.location.reload();
  };

 const handleLogout = async () => {
   disconnectSocket();
   try {
     const refreshToken = localStorage.getItem("refresh");

     // Check if the environment is local based on API_URL
     const isLocalEnvironment =
       API_URL.includes("192.168.1.109") ||
       API_URL.includes("localhost") ||
       API_URL.includes("127.0.0.1");

     // Set is_cloud to false if local, otherwise use the default isCloudValue
     const finalIsCloudValue = isLocalEnvironment ? false : isCloudValue;

     const response = await fetch(`${API_URL}/web/logout/`, {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify({
         refresh: refreshToken,
         clg_id: userID,
         is_cloud: finalIsCloudValue, // Updated value mapped here
       }),
     });
     if (!response.ok)
       console.warn(`Server logout failed with status: ${response.status}`);
   } catch (error) {
     console.error("Network error during logout:", error);
   } finally {
     localStorage.clear();
     handleAuthLogout();
     navigate("/");
   }
 };

  useEffect(() => {
    const preventBack = () => window.history.forward();
    preventBack();
    window.onunload = preventBack;

    const handleBeforeUnload = async (event) => {
      if (performance.navigation.type !== 1) await handleLogout();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  const fetchSOSData = async () => {
    try {
      const res = await fetch(`${API_URL}/web/sos_detls/`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      if (data.msg === "No Data Found") {
        setSOSData([]);
      } else {
        setSOSData(data);
      }
    } catch (error) {
      console.error("Error fetching SOS Emergency:", error);
    }
  };

  useEffect(() => {
    if (accessToken) fetchSOSData();
  }, [accessToken]);

  const sosIDRequest = (sosId) => {
    const selectedProf = sosData.find((item) => item.sos_id === sosId);
    if (selectedProf) {
      setProfID(selectedProf.sos_id);
      setRemark("");
    }
  };

  async function handleSubmitSOS(event) {
    event.preventDefault();
    if (handleEmptyRemark()) return;

    const added = parseInt(addedby, 10);
    const requestData = {
      sos_id: profID,
      action_status: 2,
      last_modified_by: added,
      last_modified_date: "",
      sos_remark: remark,
    };
    try {
      const response = await fetch(`${API_URL}/web/sos_detls/`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(requestData),
      });
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      showSnackbar("SOS Remark Submitted Successfully!", "success");
      setRemark("");
      fetchSOSData();
    } catch (error) {
      console.error("An error occurred:", error);
      showSnackbar("Failed to submit SOS remark.", "error");
    }
  }

  const formatLastName = (lastName) => {
    if (!lastName || lastName === "null" || lastName === "undefined") return "";
    return lastName;
  };

  return (
    <>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        style={{ zIndex: 99999, bottom: "20px" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%", boxShadow: 3, fontWeight: "bold" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      {/* ================================================= */}
      {/* --- PREMIUM FULL PAGE BREAK OVERLAY WITH TIMER --- */}
      {/* ================================================= */}
      <AnimatePresence>
        {isPaused && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background:
                "linear-gradient(135deg, rgba(15, 23, 42, 0.95) 0%, rgba(30, 41, 59, 0.98) 100%)",
              backdropFilter: "blur(20px)",
              WebkitBackdropFilter: "blur(20px)",
              zIndex: 9999,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
            }}
          >
            {/* Ambient Background Glow */}
            <motion.div
              animate={{ scale: [1, 1.2, 1], opacity: [0.2, 0.4, 0.2] }}
              transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
              style={{
                position: "absolute",
                width: "40vw",
                height: "40vw",
                borderRadius: "50%",
                background:
                  "radial-gradient(circle, rgba(99,102,241,0.15) 0%, transparent 70%)",
                top: "-10%",
                left: "-10%",
                pointerEvents: "none",
              }}
            />
            <motion.div
              animate={{ scale: [1, 1.5, 1], opacity: [0.1, 0.3, 0.1] }}
              transition={{
                duration: 10,
                repeat: Infinity,
                ease: "easeInOut",
                delay: 1,
              }}
              style={{
                position: "absolute",
                width: "50vw",
                height: "50vw",
                borderRadius: "50%",
                background:
                  "radial-gradient(circle, rgba(16,185,129,0.1) 0%, transparent 70%)",
                bottom: "-20%",
                right: "-10%",
                pointerEvents: "none",
              }}
            />

            {/* Central Glassmorphism Card */}
            <motion.div
              initial={{ y: 40, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{
                delay: 0.2,
                type: "spring",
                stiffness: 100,
                damping: 20,
              }}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                background: "rgba(255, 255, 255, 0.04)",
                padding: isSmallScreen ? "40px 20px" : "50px 80px",
                borderRadius: "32px",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                boxShadow:
                  "0 25px 50px -12px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255,255,255,0.05)",
                zIndex: 1,
                textAlign: "center",
              }}
            >
              {/* Floating Coffee Icon with Glow & Spinning Border */}
              <div style={{ position: "relative", marginBottom: "25px" }}>
                <motion.div
                  animate={{ rotate: 360 }}
                  transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
                  style={{
                    position: "absolute",
                    top: -10,
                    left: -10,
                    right: -10,
                    bottom: -10,
                    borderRadius: "50%",
                    border: "2px dashed rgba(139, 92, 246, 0.5)",
                  }}
                />
                <motion.div
                  animate={{ y: [0, -10, 0] }}
                  transition={{
                    duration: 4,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                  style={{
                    background:
                      "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)",
                    borderRadius: "50%",
                    padding: "20px",
                    boxShadow: "0 10px 30px rgba(139, 92, 246, 0.4)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    zIndex: 2,
                  }}
                >
                  <LocalCafeIcon sx={{ fontSize: 60, color: "#ffffff" }} />
                </motion.div>
              </div>

              <Typography
                variant={isSmallScreen ? "h4" : "h3"}
                sx={{
                  fontWeight: 800,
                  background: "linear-gradient(to right, #ffffff, #a5b4fc)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  mb: 1,
                  letterSpacing: "0.5px",
                }}
              >
                You are on a Break
              </Typography>

              {/* LIVE TIMER DISPLAY */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1.5,
                  my: 3,
                  background: "rgba(0,0,0,0.3)",
                  padding: "10px 25px",
                  borderRadius: "20px",
                  border: "1px solid rgba(255,255,255,0.05)",
                }}
              >
                <AccessTimeIcon
                  sx={{
                    color: "#34d399",
                    fontSize: 28,
                    animation: "pulse 2s infinite",
                  }}
                />
                <Typography
                  sx={{
                    fontFamily: "monospace",
                    fontSize: "2rem",
                    fontWeight: 700,
                    color: "#34d399",
                    letterSpacing: "2px",
                  }}
                >
                  {formatTimeDisplay(elapsedTime)}
                </Typography>
              </Box>

              {/* PREMIUM RESUME BUTTON */}
              <motion.div
                key="end-break"
                initial={{ scale: 0.9 }}
                animate={{ scale: 1 }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                transition={{ type: "spring", stiffness: 400, damping: 25 }}
                style={{ marginTop: "10px" }}
              >
                <Button
                  variant="contained"
                  size="large"
                  startIcon={
                    <PlayCircleFilledIcon
                      sx={{
                        fontSize: "26px !important",
                        color: "#ffffff",
                        mr: 0.5,
                      }}
                    />
                  }
                  sx={{
                    background:
                      "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                    fontSize: "18px",
                    height: "56px",
                    fontWeight: 700,
                    textTransform: "none",
                    borderRadius: "28px",
                    padding: "0 40px",
                    color: "#ffffff",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    boxShadow: "0 10px 25px rgba(16, 185, 129, 0.3)",
                    position: "relative",
                    overflow: "hidden",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg, #059669 0%, #047857 100%)",
                      boxShadow: "0 15px 35px rgba(16, 185, 129, 0.5)",
                    },
                  }}
                  onClick={handleUnpause}
                >
                  Resume Work
                </Button>
              </motion.div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <Box
        style={{ position: "fixed", top: 0, width: "100%", zIndex: 1000 }}
        className="navbar-body"
      >
        <AppBar
          position="static"
          style={{
            background:
              "linear-gradient(90deg, rgb(123 110 110) 0%, rgb(94, 126, 158) 100%)",
            height: "3rem",
          }}
        >
          <Toolbar
            variant="dense"
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            {!isSmallScreen && (
              <div style={{ display: "flex" }}>
                <Typography
                  variant="h6"
                  component="div"
                  align="left"
                  sx={{
                    flexGrow: 1,
                    fontFamily: "sans-serif",
                    fontWeight: 600,
                    fontStyle: "normal",
                    color: "white",
                    marginLeft: "12px",
                    textDecoration: "none",
                  }}
                >
                  Spero Home Healthcare Private Limited
                </Typography>
              </div>
            )}

            {auth && (
              <Stack
                direction="row"
                justifyContent="flex-end"
                alignItems={isSmallScreen ? "center" : "stretch"}
                sx={{ mr: -3 }}
              >
                <Box
                  sx={{ display: "flex", gap: 1, mr: 3, alignItems: "center" }}
                >
                  <AnimatePresence mode="wait">
                    {!isPaused && (
                      <motion.div
                        key="start-break"
                        initial={{ opacity: 0, y: -15, filter: "blur(4px)" }}
                        animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                        exit={{ opacity: 0, y: 15, filter: "blur(4px)" }}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        transition={{
                          type: "spring",
                          stiffness: 400,
                          damping: 25,
                        }}
                      >
                        <Button
                          variant="contained"
                          size="small"
                          startIcon={
                            <LocalCafeIcon
                              sx={{
                                fontSize: "14px !important",
                                color: "#FFE8E8",
                              }}
                            />
                          }
                          sx={{
                            background:
                              "linear-gradient(135deg, #FF7676 0%, #E53935 100%)",
                            fontSize: "10px",
                            height: "28px",
                            fontWeight: 800,
                            textTransform: "none",
                            borderRadius: "16px",
                            padding: "0 14px",
                            border: "1px solid rgba(255, 255, 255, 0.4)",
                            boxShadow: "0 4px 10px rgba(229, 57, 53, 0.4)",
                            letterSpacing: "0.5px",
                            overflow: "hidden",
                            position: "relative",
                            "&:hover": {
                              background:
                                "linear-gradient(135deg, #E53935 0%, #C62828 100%)",
                              boxShadow: "0 6px 15px rgba(229, 57, 53, 0.6)",
                            },
                            "&::after": {
                              content: '""',
                              position: "absolute",
                              top: 0,
                              left: "-100%",
                              width: "50%",
                              height: "100%",
                              background:
                                "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)",
                              transition: "all 0.6s ease-in-out",
                            },
                            "&:hover::after": {
                              left: "100%",
                            },
                          }}
                          onClick={() => setIsBreakModalOpen(true)}
                        >
                          Start Break
                        </Button>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </Box>

                <div
                  style={{
                    marginBottom: isSmallScreen ? "10px" : "0px",
                    marginTop: isSmallScreen ? "0px" : "20px",
                  }}
                >
                  Welcome, {userName} {formatLastName(userLastName)}
                </div>
                <IconButton
                  size="large"
                  onClick={handleMenu}
                  color="inherit"
                  sx={{ mr: -3 }}
                >
                  <Avatar alt="User avatar" src="/static/images/avatar/2.jpg" />
                </IconButton>
                <Button onClick={toggleDrawer(true)}>
                  <img
                    src={SOS}
                    alt="SOS"
                    style={{ height: "45px", marginBottom: "3px" }}
                  />
                </Button>

                <Drawer
                  anchor="right"
                  open={state.right}
                  onClose={toggleDrawer(false)}
                  PaperProps={{
                    style: {
                      height: "92%",
                      borderRadius: "5px",
                      marginTop: "2px",
                    },
                  }}
                >
                  <AppBar
                    position="static"
                    style={{
                      background:
                        "linear-gradient(90deg, rgb(123 110 110) 0%, rgb(94, 126, 158) 100%)",
                      width: "20rem",
                      height: "3rem",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <Typography
                        align="left"
                        style={{
                          fontSize: "16px",
                          fontWeight: 600,
                          color: "#FFFFFF",
                          marginTop: "10px",
                          marginLeft: "18px",
                        }}
                      >
                        SOS Requests
                      </Typography>
                      <Button
                        onClick={toggleDrawer(false)}
                        sx={{
                          marginLeft: "8rem",
                          color: "#FFFFFF",
                          marginTop: "2px",
                        }}
                      >
                        <CloseIcon />
                      </Button>
                    </div>

                    <div
                      style={{
                        marginTop: "25px",
                        marginLeft: "20px",
                        marginRight: "20px",
                        marginBottom: "10px",
                      }}
                    >
                      {Array.isArray(sosData) &&
                        sosData.map((item, index) => (
                          <div key={index}>
                            <Grid item xs={12}>
                              <Grid
                                container
                                style={{ justifyContent: "space-between" }}
                              >
                                <Typography
                                  inline
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Name
                                </Typography>
                                <Typography
                                  inline
                                  variant="subtilte2"
                                  color="text.primary"
                                  onClick={() => sosIDRequest(item.sos_id)}
                                  style={{ cursor: "pointer" }}
                                >
                                  {item ? item.srv_prof_id : ""}
                                </Typography>
                              </Grid>
                              <Grid
                                container
                                style={{
                                  justifyContent: "space-between",
                                  marginTop: "2px",
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Contact Number
                                </Typography>
                                <Typography
                                  variant="subtilte2"
                                  color="text.primary"
                                >
                                  +91 {item ? item.srv_prof_con : ""}
                                </Typography>
                              </Grid>
                              <Grid
                                container
                                style={{
                                  justifyContent: "space-between",
                                  marginTop: "1px",
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{ color: "#f44336" }}
                                >
                                  Date & Time
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{ color: "#f44336" }}
                                >
                                  {formatTime(
                                    item ? item.last_modified_date : "",
                                  )}
                                </Typography>
                              </Grid>
                              {profID === item.sos_id && (
                                <Grid
                                  item
                                  xs={12}
                                  container
                                  spacing={1}
                                  sx={{ mt: 0.5 }}
                                >
                                  <Grid item lg={9} sm={9} xs={9}>
                                    <TextField
                                      required
                                      label="Remark"
                                      id="sos_remark"
                                      name="sos_remark"
                                      value={remark}
                                      onChange={(e) =>
                                        setRemark(e.target.value)
                                      }
                                      placeholder="Remark"
                                      size="small"
                                      fullWidth
                                      error={!!remarkError.remark}
                                      helperText={remarkError.remark}
                                      sx={{ "& input": { fontSize: "14px" } }}
                                    />
                                  </Grid>
                                  <Grid item lg={3} sm={3} xs={3}>
                                    <Button
                                      variant="contained"
                                      onClick={handleSubmitSOS}
                                    >
                                      <CheckOutlinedIcon />
                                    </Button>
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>
                            {index < sosData.length - 1 && (
                              <hr sx={{ my: 2 }} />
                            )}
                          </div>
                        ))}
                    </div>
                  </AppBar>
                </Drawer>

                {/* Profile/Logout Menu */}
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  keepMounted
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handleProfile}>
                    <PersonOutlineIcon
                      style={{ fontSize: "20px", marginRight: "10px" }}
                    />
                    Profile
                  </MenuItem>
                  <MenuItem onClick={handleLogout}>
                    <PowerSettingsNewIcon
                      style={{ fontSize: "20px", marginRight: "10px" }}
                    />
                    Logout
                  </MenuItem>
                </Menu>

                {/* Profile Info Modal */}
                <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
                  <Box
                    sx={{
                      width: 280,
                      height: 200,
                      p: 2,
                      position: "absolute",
                      top: "28%",
                      left: "86%",
                      transform: "translate(-50%, -50%)",
                      bgcolor: "#F5F5F5",
                      borderRadius: "8px",
                      "@media (max-width: 600px)": { left: "50%" },
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <IconButton size="large" color="inherit">
                        <Avatar
                          alt="User Avatar"
                          src="/static/images/avatar/2.jpg"
                        />
                      </IconButton>
                      <Typography variant="subtitle2" sx={{ mt: 2 }}>
                        {userName} {userLastName} <br />
                        Healthcare Attendent
                      </Typography>
                    </div>
                    <br />
                    <div className="contact-info">
                      <EmailOutlinedIcon sx={{ color: "#69A5EB" }} />
                      <Typography variant="body2">{userEmail}</Typography>
                    </div>
                    <br />
                    <div className="contact-info">
                      <LocalPhoneOutlinedIcon sx={{ color: "#69A5EB" }} />
                      <Typography variant="body2">{userPhone}</Typography>
                    </div>
                    <br />
                    <div className="contact-info">
                      <LocationOnOutlinedIcon sx={{ color: "#69A5EB" }} />
                      <Typography variant="body2">{userAddress}</Typography>
                    </div>
                  </Box>
                </Modal>

                {/* ================================================= */}
                {/* --- PREMIUM MAPPED MODAL: BREAK TYPE SELECTION --- */}
                {/* ================================================= */}
                {/* ================================================= */}
                {/* --- PREMIUM MAPPED MODAL: BREAK TYPE SELECTION --- */}
                {/* ================================================= */}
                <Modal
                  open={isBreakModalOpen}
                  onClose={() => setIsBreakModalOpen(false)}
                  sx={{
                    display: "flex", // <-- Yeh Modal ko Center karega
                    alignItems: "center", // <-- Vertical Center
                    justifyContent: "center", // <-- Horizontal Center
                    backdropFilter: "blur(12px)",
                    backgroundColor: "rgba(0,0,0,0.4)",
                  }}
                >
                  <AnimatePresence>
                    {isBreakModalOpen && (
                      <motion.div
                        initial={{ scale: 0.8, opacity: 0, y: 30 }}
                        animate={{ scale: 1, opacity: 1, y: 0 }}
                        exit={{ scale: 0.8, opacity: 0, y: 30 }}
                        transition={{
                          type: "spring",
                          stiffness: 300,
                          damping: 25,
                        }}
                        style={{
                          width: 340,
                          outline: "none",
                          // Yahan se position: absolute hata diya gaya hai
                        }}
                      >
                        <Box
                          sx={{
                            p: 4,
                            bgcolor: "rgba(255, 255, 255, 0.95)",
                            borderRadius: "24px",
                            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
                            border: "1px solid rgba(255,255,255,0.6)",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          {/* Modal Icon Glow */}
                          <Box
                            sx={{
                              background:
                                "linear-gradient(135deg, #FF7676 0%, #E53935 100%)",
                              borderRadius: "50%",
                              p: 2,
                              mb: 2,
                              boxShadow: "0 10px 20px rgba(229, 57, 53, 0.3)",
                            }}
                          >
                            <LocalCafeIcon
                              sx={{ color: "white", fontSize: 32 }}
                            />
                          </Box>

                          <Typography
                            variant="h5"
                            sx={{
                              mb: 3,
                              fontWeight: 800,
                              color: "#1e293b",
                              textAlign: "center",
                            }}
                          >
                            Take a Break
                          </Typography>

                          <FormControl fullWidth sx={{ mb: 4 }}>
                            <InputLabel
                              id="break-type-modal-label"
                              sx={{ fontWeight: 600 }}
                            >
                              Select Break Type
                            </InputLabel>
                            <Select
                              labelId="break-type-modal-label"
                              value={selectedBreakType}
                              label="Select Break Type"
                              onChange={(e) =>
                                setSelectedBreakType(e.target.value)
                              }
                              sx={{
                                borderRadius: "12px",
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "rgba(0,0,0,0.1)",
                                  borderWidth: "2px",
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "#E53935",
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    borderColor: "#E53935",
                                  },
                              }}
                            >
                              {breakTypes.map((b) => (
                                <MenuItem
                                  key={b.break_type_id}
                                  value={b.break_type_id}
                                  sx={{ fontWeight: 500 }}
                                >
                                  {b.break_type_name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          <Stack direction="row" spacing={2} width="100%">
                            <Button
                              fullWidth
                              variant="outlined"
                              onClick={() => setIsBreakModalOpen(false)}
                              sx={{
                                borderRadius: "12px",
                                textTransform: "none",
                                fontWeight: 700,
                                color: "#64748b",
                                borderColor: "#cbd5e1",
                                "&:hover": {
                                  borderColor: "#94a3b8",
                                  background: "#f1f5f9",
                                },
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              fullWidth
                              variant="contained"
                              onClick={handlePause}
                              disabled={!selectedBreakType}
                              sx={{
                                borderRadius: "12px",
                                textTransform: "none",
                                fontWeight: 700,
                                background:
                                  "linear-gradient(135deg, #EF4444 0%, #B91C1C 100%)",
                                boxShadow: "0 8px 15px rgba(239, 68, 68, 0.3)",
                                "&:hover": {
                                  background:
                                    "linear-gradient(135deg, #DC2626 0%, #991B1B 100%)",
                                  boxShadow:
                                    "0 10px 20px rgba(239, 68, 68, 0.5)",
                                },
                                "&:disabled": {
                                  background: "#e2e8f0",
                                  color: "#94a3b8",
                                },
                              }}
                            >
                              Start
                            </Button>
                          </Stack>
                        </Box>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </Modal>
                {/* ================================================= */}
                {/* ================================================= */}
              </Stack>
            )}
          </Toolbar>
        </AppBar>

        <div style={{ marginTop: 0 }}>
          {userGroup !== "HHC_Analytics" && userGroup !== "M_DASH" && (
            <Header />
          )}
        </div>
      </Box>
    </>
  );
}
